// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'wifi-none';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinejoin='round'>
    <path
      strokeLinecap='round'
      d='M4.722 8.493a3.719 3.719 0 0 1 4.695-.458M2.675 6.04A6.906 6.906 0 0 1 12 6.02M1.031 3.253a10.095 10.095 0 0 1 12.644.005m-.956 9.992v-2.125m4.117 4.025a1.257 1.257 0 0 1-1.124 1.819H9.725a1.255 1.255 0 0 1-1.124-1.819l2.994-5.986a1.256 1.256 0 0 1 2.248 0z'
    />
    <path d='M12.719 15.375a.266.266 0 1 1 0-.531m0 .531a.266.266 0 0 0 0-.531' />
  </g>
);

export const viewBox = '0 0 18 18';
